import { useAuth } from '../contexts/AuthContext';
import InvoiceScanner from '../shared/InvoiceScanner';

const DriverExpensesPage = () => {
  const { token } = useAuth();
  return <InvoiceScanner token={token} title="Mes depenses" />;
};

export default DriverExpensesPage;
